import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import classNames from 'classnames';



const styles = theme => ({
   leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  root: {
    width: '100%',    
    textAlign:"center"
    
  },
  tableContainer:
  {
    display:"inline-block",
    width: '100%',
    //maxWidth: '80%',
  },
  paper: {
    display:"inline-block",
    width: '100%',
    //maxWidth: '80%',
    marginTop: theme.spacing.unit * 3,
    overflow: 'visible'
  },
  table: {
    minWidth: 700,
    overflow: "visible"
  },
  tableHead:
  {
    backgroundColor: "#aaa"
  },
   
  tableRow:
  {
    overflow: "visible"
  },
   button: {
    margin: theme.spacing.unit,
  },
  tableCellAssign:
  {
    overflow: "visible",
  },
  tableCellAssignDiv:
  {
    overflow: "visible",
    height: "40px",
    width: "300px"
  },
  tableRowHover: {
     cursor: 'pointer',
    '&:hover': {
      backgroundColor: "#777",
    },
  },
   tableRowSelected: {
    backgroundColor: "#666"
  },
  buttonContainer:
  {
    width: '100%',
    maxWidth: '80%',
    height: '150px', //some spacing to click on to remove selection
    display:"inline-block",
  },
  buttonContainerLeft:
  {
    float: "left"
  },
  buttonContainerRight:
  {
    float: "right"
  },
});


export class SimpleTable extends Component {
  static propTypes = {
    titleRow: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    maxWidth: PropTypes.string
  };

  static defaultProps = {
    editText: "Edit",
    addText: "New",
    deleteText: "Delete",
    editable: true
  };

   state = {
    selectedRow: -1,
    editDialogOpen: false,
    editDialogNode: <div />
  };

  onCloseEditDialog()
  {
    this.setState({editDialogOpen: false, editDialogNode: {}});
  }

  isString(obj)
  {
    return (typeof obj === 'string' || obj instanceof String);
  }

  render() {

    

    const { classes, rows, titleRow } = this.props;

    return (
     <div className={classes.root}  onClick={(event) => {console.log(this.state.editDialogOpen);if (!this.state.editDialogOpen) { console.log("unselect");event.stopPropagation();this.setState({selectedRow:-1}); }}}>
    <div className={classes.tableContainer}>
    
    
      <Table className={classes.table}>
        <TableHead  className={classes.tableHead}>
          <TableRow>
                                {titleRow.map((c, i) => <TableCell key={i}>{c}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row,idx) => {
            return (
              <TableRow key={idx} className = {row.selectable ? classNames(classes.tableRow, classes.tableRowHover,this.state.selectedRow === idx && classes.tableRowSelected): classes.tableRow} onClick={(event) => {if (row.selectable) {event.stopPropagation(); this.setState({selectedRow : idx})}}}>
                  
                    {row.columns.map((c, i) => <TableCell key={i} style={row.styles && row.styles[i]}>{c}</TableCell>)}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      
    
    
      </div>
      </div>
    )
  }
}


export default withStyles(styles)(SimpleTable);


// WEBPACK FOOTER //
// ./src/features/common/SimpleTable.js